import React, { memo } from 'react';
import PropTypes from 'prop-types';

const GraphColor = (props) => (
  <svg {...props} viewBox="0 0 40 40">
    <g fill="none" fillRule="evenodd">
      <g
        fill={props.transparent || '#7FE3FF'}
        transform="translate(10.625 .625)"
      >
        <circle cx="3.438" cy="10.938" r="2.188" />
        <circle cx="15.938" cy="14.688" r="2.188" />
        <circle cx="25.938" cy="2.188" r="2.188" />
        <circle cx="25.938" cy="19.688" r="2.188" />
        <circle cx="14.688" cy="26.563" r="2.188" />
        <circle cx="2.188" cy="26.563" r="2.188" />
      </g>
      <path
        fill="#042238"
        d="M36.667 0C38.507 0 40 1.505 40 3.36c0 1.854-1.493 3.36-3.333 3.36-.543 0-1.055-.131-1.507-.363l-5.648 7.232c.437.568.696 1.28.696 2.054 0 1.856-1.492 3.36-3.333 3.36-1.84 0-3.333-1.504-3.333-3.36v-.071l-6.56-2.133A3.325 3.325 0 0 1 14.168 15a3.31 3.31 0 0 1-2.329-.956L1.666 20.263v13.423l8.007-5.31a3.374 3.374 0 0 1-.137-.79l-.005-.184c0-1.855 1.493-3.36 3.333-3.36a3.34 3.34 0 0 1 3.229 2.52h5.887a3.34 3.34 0 0 1 3.228-2.52c.93 0 1.773.385 2.377 1.005l5.873-3.451a3.388 3.388 0 0 1-.125-.914c0-1.854 1.493-3.36 3.334-3.36 1.84 0 3.333 1.506 3.333 3.36 0 1.856-1.493 3.36-3.333 3.36a3.31 3.31 0 0 1-2.369-.996l-5.877 3.456c.079.286.12.588.12.9 0 1.855-1.492 3.36-3.333 3.36a3.34 3.34 0 0 1-3.228-2.52h-5.887a3.338 3.338 0 0 1-3.229 2.52 3.31 3.31 0 0 1-2.323-.952l-8.875 5.886v2.623l36.667.001c.41 0 .75.297.82.69l.014.15a.838.838 0 0 1-.684.826l-.15.014H.833a.835.835 0 0 1-.82-.689L0 39.161V1.364C0 .9.373.525.833.525c.41 0 .75.297.82.689l.014.15-.001 16.934 9.308-5.689a3.375 3.375 0 0 1-.136-.784l-.005-.185c0-1.854 1.493-3.36 3.334-3.36 1.84 0 3.333 1.506 3.333 3.36 0 .067-.002.134-.006.2l6.5 2.114a3.328 3.328 0 0 1 2.881-1.67c.469 0 .915.097 1.32.273l5.712-7.313a3.362 3.362 0 0 1-.574-1.884c0-1.855 1.493-3.36 3.334-3.36ZM12.864 25.722c-.92 0-1.666.753-1.666 1.68 0 .928.746 1.68 1.666 1.68.922 0 1.667-.752 1.667-1.68 0-.928-.746-1.68-1.667-1.68Zm12.344 0c-.92 0-1.666.753-1.666 1.68 0 .928.746 1.68 1.666 1.68.92 0 1.667-.752 1.667-1.68a1.681 1.681 0 0 0-.222-.834l-.003-.01a1.664 1.664 0 0 0-1.442-.836Zm11.459-6.72c-.92 0-1.667.753-1.667 1.68 0 .928.746 1.68 1.667 1.68.92 0 1.666-.752 1.666-1.68 0-.927-.747-1.68-1.666-1.68Zm-9.792-5.039c-.92 0-1.667.753-1.667 1.68 0 .928.747 1.68 1.667 1.68s1.667-.752 1.667-1.68c0-.53-.245-1.004-.627-1.312a.157.157 0 0 1-.029-.02l-.013-.013a1.65 1.65 0 0 0-.998-.335ZM14.167 9.961c-.92 0-1.667.752-1.667 1.68 0 .307.082.595.225.842a.108.108 0 0 1 .02.026l.01.025c.295.473.817.786 1.412.786.92 0 1.666-.752 1.666-1.68 0-.927-.747-1.68-1.666-1.68Zm22.5-8.281c-.92 0-1.667.753-1.667 1.68 0 .927.747 1.68 1.667 1.68s1.666-.753 1.666-1.68c0-.927-.747-1.68-1.666-1.68Z"
      />
    </g>
  </svg>
);

GraphColor.defaultProps = {
  width: 40,
  height: 40,
};

GraphColor.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default memo(GraphColor);
